import { shouldUsePendingBlockPath } from "./clientBlockPathResolver";

export const usesPendingInvitationWorkspace = (client) =>
  shouldUsePendingBlockPath(client) === true;

export const shouldSkipUserScopedForms = (client) =>
  usesPendingInvitationWorkspace(client);

export const supportsUserScopedForms = (client) =>
  !shouldSkipUserScopedForms(client);

const normalizePendingUserId = (value) => String(value ?? "").trim().toLowerCase();

export const shouldRefreshPendingWorkspaceDiscoverabilityAfterMutation = ({
  client,
  coachClients = [],
} = {}) => {
  if (!usesPendingInvitationWorkspace(client)) return false;

  const pendingUserId = normalizePendingUserId(client?.pendingUserId);
  if (!pendingUserId) return false;

  const hasVisiblePendingInvitationClientForWorkspace =
    Array.isArray(coachClients) &&
    coachClients.some((coachClient) => {
      if (!usesPendingInvitationWorkspace(coachClient)) return false;
      return normalizePendingUserId(coachClient?.pendingUserId) === pendingUserId;
    });

  return !hasVisiblePendingInvitationClientForWorkspace;
};
